<template>
  <quizset-form>
    <ButtonCreate class="mt_m"/>
  </quizset-form>
</template>

<script>
import QuizsetForm from '@/components/Quizset/Form'
import ButtonCreate from '@/components/Quizset/ButtonCreate'

export default {
  components: {
    QuizsetForm,
    ButtonCreate
  },
  created: async function () {
    this.$store.dispatch('quizset/resetForm')
  }
}
</script>
